// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.absolute__kpLnp{position:absolute;width:100vw;height:100vh;z-index:var(--loader-z-index)}`, "",{"version":3,"sources":["webpack://./src/components/loader/Loader.module.scss"],"names":[],"mappings":"AAAA,iBACC,iBAAA,CACA,WAAA,CACA,YAAA,CACA,6BAAA","sourcesContent":[".absolute {\n\tposition: absolute;\n\twidth: 100vw;\n\theight: 100vh;\n\tz-index: var(--loader-z-index);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"absolute": `absolute__kpLnp`
};
export default ___CSS_LOADER_EXPORT___;
